module.exports = __webpack_public_path__ + "img/ic_bubble_6.cfac865.svg";